import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { BackendResponse } from "app/model/backend-response.model";
import { BehaviorSubject } from "rxjs/Rx";
import { AuthenticationService } from "app/service/authentication.service";
import { Router } from "@angular/router";

@Injectable()
export class CustomHttp extends Http {
  public _successResponseSubject: BehaviorSubject<BackendResponse>;
  public _errorResponseSubject: BehaviorSubject<BackendResponse>;

  getSuccessResponseSubject() {
    return this._successResponseSubject.asObservable();
  }

  getErrorResponseSubject() {
    return this._errorResponseSubject.asObservable();
  }

  constructor(public router: Router,
              backend: XHRBackend, options: RequestOptions) {
    super(backend, options);
    this._successResponseSubject = <BehaviorSubject<BackendResponse>>new BehaviorSubject(undefined);
    this._errorResponseSubject = <BehaviorSubject<BackendResponse>>new BehaviorSubject(undefined);
  }

  // Do not catch exceptions here
  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::request");
    if (localStorage.getItem('currentUser') !== null) {
      this.setBearerToken(url,
        JSON.parse(localStorage.getItem('currentUser')).token, options);
    } else if (localStorage.getItem('currentGaleri') !== null) {
      this.setBearerToken(url,
        JSON.parse(localStorage.getItem('currentGaleri')).token, options);
    }
    return super.request(url, options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::get");
    return super.get(url, options)
      .catch(this.catchError(this));
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::post");
    return super.post(url, body, options)
      .map(this.mapResponse(this))
      .catch(this.catchError(this));
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::put");
    return super.put(url, body, options)
      .map(this.mapResponse(this))
      .catch(this.catchError(this));
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::delete");
    return super.delete(url, options)
      .map(this.mapResponse(this))
      .catch(this.catchError(this));
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::patch");
    return super.patch(url, body, options);
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::head");
    return super.head(url, options);
  }

  options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.debug(">> CustomHttp::options");
    return super.options(url, options);
  }

  public setBearerToken(url: string | Request, token: string, options?: RequestOptionsArgs) {
    // meaning we have to add the token to the options, not in url
    if (typeof url === 'string') {
      if (!options) {
        // let's make option object
        options = { headers: new Headers() };
      }
      options.headers.set('Authorization', `Bearer ${token}`);
    } else {
      // we have to add the token to the url object
      url.headers.set('Authorization', `Bearer ${token}`);
    }
  }

  // we have to pass HttpService's own instance here as `self`
  public mapResponse(self: CustomHttp) {
    return (res: Response) => {
      console.debug("--> mapResponse: " + res);
      let status: number = res.json()['status'];
      let code: string = res.json()['code'];
      let message: string = res.json()['message'];

      if (res.status === 200) {
        return this.pushToSubjectAndReturn(res.status, String(code), message, true);
      }
    };
  }

  // we have to pass HttpService's own instance here as `self`
  public catchError(self: CustomHttp) {
    return (res: Response | any) => {
      console.debug("--> catchError: " + res);

      let status: number = res.json()['status'];
      let code: string = res.json()['code'];
      let message: string = res.json()['message'];

      // If token_expired, then logout
      if (code === "400.002") {

        if (localStorage.getItem('currentUser') !== null) {
          localStorage.removeItem('currentUser');
        } else if (localStorage.getItem('currentGaleri') !== null) {
          localStorage.removeItem('currentGaleri');
        }

      }

      this.pushToSubjectAndReturn(status, String(code), message, false);
      return Observable.throw(
        this.router.navigate(['/islem-hata'])
      );
    };
  }

  public pushToSubjectAndReturn(status: number, code: string, message: string, success: boolean) {
    let backResp: BackendResponse = new BackendResponse(status, String(code), message);
    if (success) {
      this._successResponseSubject.next(Object.assign({}, backResp));
    } else {
      this._errorResponseSubject.next(Object.assign({}, backResp));
    }
    return backResp;
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/customhttp.ts